export default __webpack_public_path__ + "ddc358788b801d87575adb488f0fcb80.png";